import { render, staticRenderFns } from "./ArticleTypeBuilder.vue?vue&type=template&id=6a6e4a1d"
import script from "./ArticleTypeBuilder.vue?vue&type=script&lang=js"
export * from "./ArticleTypeBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports